export default "__VITE_ASSET__Cl5Wb$Uw__"